export default function objectToParameter(object = {}) {
  return Object.keys(object)
    .map(key => `${key}=${object[key]}`)
    .join('&');
};
